module.exports = __webpack_public_path__ + "static/btn02-507d5173f49277274c6b905587b613f5.png";